(function () {


    const section = document.querySelector(`[id="product"]`);
    const product = JSON.parse(section.querySelector(".productJSON").textContent);


    // set up images swiper
    let productSwiper = new Swiper('#productSwiper', {
        slidesPerView: 1,
        spaceBetween: 50,
        autoHeight: true,
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productThumbsItem").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });


    // update active variant
    let formData = {
        items: []
    };


    // top cover is based of weight (SILVER INSOLES)
    let weightToTopCover = {
        "70 - 100lbs": "L",
        "100 - 120lbs": "L",
        "121 - 150lbs": "L",
        "151 - 180lbs": "H",
        "181 - 210lbs": "H",
        "211 - 230lbs": "H",
        "231 - 260lbs": "H",
        "261lbs - Up": "H"
    };


    // function to take variables from product options to a formdata item
    function getFormData(options, targetHandle) {
        // gender is a variant (make sure something is checked)
        let gender = options.gender ?? null;

        // sport is a property
        let sport = options.sport ?? null;

        // size is a variant
        let size = options.size ?? null;

        // weight is a property
        let weight = options.weight ?? null;

        // age is a property
        let age = options.age ?? null;

        // Determine product
        let targetProduct = silverProduct;

        // Determine Top Cover
        let topCover = weightToTopCover[weight];

        console.log(size)

        // overrides
        // 37-H -> 37-L
        // 38-H -> 38-L
        if (
            gender === "Male" && size === "5" ||
            gender === "Male" && size === "5.5" ||
            gender === "Female" && size === "7" ||
            gender === "Female" && size === "7.5" ||
            gender === "Male" && size === "6" ||
            gender === "Male" && size === "6.5" ||
            gender === "Female" && size === "8" ||
            gender === "Female" && size === "8.5"

        ) {
            topCover = "L";
        }

        // 43-L -> 43-H
        // 44-L -> 44-H
        // 45-L -> 45-H
        if (
            gender === "Male" && size === "11" ||
            gender === "Male" && size === "11.5" ||
            gender === "Female" && size === "13" ||
            gender === "Female" && size === "13.5" ||
            gender === "Male" && size === "12" ||
            gender === "Male" && size === "12.5" ||
            gender === "Male" && size === "13" ||
            gender === "Male" && size === "13.5"
        ) {
            topCover = "H";
        }

        // athletes over 50 and 151-180 receive a topCover of L
        if (age === "50 and Up" && weight === "151 - 180lbs") {
            topCover = "L";
        }

        // option order is size, top cover, gender
        // find the correct variant based on the active options
        let activeVariant = null;
        for (let i = 0; i < targetProduct.variants.length; i++) {

            // here comes the tricky part, Shopfiy might have 5-5.5 OR 5.5-6 ending on the top cover however we're going to receive a size of 5, 5.5 or 6.
            // We need to do a split and find an exact match
            if (
                // size
                targetProduct.variants[i].option1.split("-").includes(size) &&
                // top cover
                targetProduct.variants[i].option2 === topCover &&
                // gender
                targetProduct.variants[i].option3 === gender
            ) {
                activeVariant = targetProduct.variants[i];
                break;
            }
        }


        // check if active variant is not found in any setup
        if (activeVariant == null) {
            return false;
        }

        // gather item
        let formData = {
            quantity: 1,
            id: activeVariant.id,
            properties: {
                "Age": age,
                "Sport": sport,
                "Weight": weight
            },
            available: activeVariant.available
        };

        // return
        return formData;

    }

    /**************
     Product Slider
     ***************/

        // enable swiper
    let productFormSwiper = new Swiper(".productFormSwiper", {
            allowTouchMove: false,
            autoHeight: true,
            spaceBetween: 30
        });


    // Progress bar
    productFormSwiper.on("slideChange", function () {
        // enable all buttons
        section.querySelectorAll('.productFormProgressCircleInner').forEach((element) => {
            element.disabled = false;
        });


        // update active progress bar circles
        section.querySelectorAll(".productFormProgressCircle")?.forEach((element, index) => {
            if (index <= productFormSwiper.activeIndex) {
                // we need to wait to add the active class
                // because the progress bar takes 300ms to animate
                setTimeout(() => {
                    element.classList.add("active");
                }, 100);
            } else {
                element.classList.remove("active");
            }
        });

        // update active progress bar lines
        section.querySelectorAll(".productFormProgressLineInner").forEach((element, index) => {
            element.classList.remove("active");
            if (index < productFormSwiper.activeIndex) {
                element.classList.add("active");
            }
        });

        // Progress bar button click slide change
        section.querySelectorAll('.productFormProgressCircle.active').forEach((element, index) => {
            element.addEventListener("click", function () {
                productFormSwiper.slideTo(index);
            });
        });

    });


    // Progress bar final slide edge cases
    // The final form is the last "slide" but isn't a swiper slide.
    // We need to add the active class to the final progress bar/circle when
    // the last swiper slide option is clicked, which is the weight group for platinum
    // and is the age group for silver/gold.
    let targetGroup = "age"


    section.querySelectorAll(`.productFormOptionSlideLabel[data-group='${targetGroup}']`)?.forEach(element => {
        element.addEventListener("click", function () {
            // add active class to all progress bar circles
            section.querySelectorAll(".productFormProgressCircle")?.forEach((element, index) => {
                element.classList.add("active");
            });
            // add active class to all progress bar lines
            section.querySelectorAll(".productFormProgressLineInner")?.forEach((element, index) => {
                element.classList.add("active");
            });

            // Since we're on the last slide, we need to disable the buttons
            section.querySelectorAll('.productFormProgressCircleInner').forEach((element) => {
                element.disabled = true;
            });
        });
    });


    // update active variant on click
    section.querySelectorAll(".productFormOptionSlideLabel").forEach(function (element) {
        element.addEventListener("click", function () {


            const group = this.dataset.group;
            const value = this.dataset.value;

            // remove active class from all items in this group
            section.querySelectorAll(`.productFormOptionSlideLabel[data-group="${group}"]`).forEach(element => element.classList.remove("active"));

            // add active class to this item
            this.classList.add("active");

            // go to next slide
            productFormSwiper.slideNext();

            // // slide back up to top of productFormSwiper - 200px - only on the shoe slide
            // if (group === "size") {
            //     let elementTop = section.querySelector('.productFormSwiper').getBoundingClientRect().top + window.scrollY;
            //     let offset = 300;
            //     if (window.innerWidth < 800) {
            //         offset = 250;
            //     }
            //     window.scrollTo({
            //         top: elementTop - offset,
            //         behavior: 'smooth'
            //     });
            // }

            // check if every group has an active item
            if (section.querySelectorAll(".productFormOptionSlide").length === section.querySelectorAll(".productFormOptionSlideLabel.active").length) {
                section.querySelector(".productFormWrap").classList.remove("active");
                section.querySelector(".productFormSwiper").classList.remove("active");
                section.querySelector(".productFormForm").classList.add("active");
            } else {
                section.querySelector(".productFormWrap").classList.add("active");
                section.querySelector(".productFormSwiper").classList.add("active");
                section.querySelector(".productFormForm").classList.remove("active");
                return;
            }

            // create options object
            let options = {};
            section.querySelectorAll(`.productFormOptionSlideLabel.active`).forEach(element => {
                options[element.dataset.group] = element.dataset.value;
            });

            // save options
            section.querySelector(".productFormPair").setAttribute("options", JSON.stringify(options));
            section.querySelector(".productFormPair").classList.add("active");


            // update product
            updateProduct();


        });
    })


    // back button
    section.querySelectorAll(".productFormSwiperNavBack").forEach(function (element) {
        element.addEventListener("click", function () {
            productFormSwiper.slidePrev();
        });
    });

    // next button
    section.querySelectorAll(".productFormSwiperNavNext").forEach(function (element) {
        element.addEventListener("click", function () {
            productFormSwiper.slideNext();
        });
    });

    /*******************
     * Product Pairs
     */

    // open edit
    section.querySelectorAll(".productFormPairEdit").forEach(element => {
        element.addEventListener("click", function () {
            // save pair element
            let pairElement = this.closest(".productFormPair");

            // save option element
            let options = pairElement.getAttribute("options");

            // open modal
            pairElement.querySelector(".productFormPairModal").showModal();

            // select options
            let optionsParsed = JSON.parse(options);
            pairElement.querySelectorAll(`.productFormPairModalLabelSelect`).forEach(element => {
                element.value = optionsParsed[element.getAttribute("name")]
            });

        })
    });

    // close event
    section.querySelectorAll(".productFormPairModal").forEach(element => {
        element.addEventListener('close', function () {

            // save pair element
            let pairElement = this.closest(".productFormPair");

            // check if this input has no options, then we hide it (it means they added a product with different options and canclled)
            if (!pairElement.getAttribute("options")) {
                pairElement.classList.remove("active");
            }

        });
    })

    // trigger close modal
    section.querySelectorAll(".productFormPairModal,.productFormPairModalCancel,.productFormPairModalExit").forEach(element => {
        element.addEventListener("click", function (e) {
            if (e.target === this) {
                section.querySelector(".productFormPairModal[open]").close();
            }
        })
    });

    // form input events
    section.querySelectorAll(".productFormPairModalLabelSelect").forEach(element => element.addEventListener("change", function () {
        // check if the entire form is ready
        let form = this.closest(".productFormPairModalContent");

        // check if all inputs are entered
        let ready = true;
        form.querySelectorAll(".productFormPairModalLabelSelect").forEach(input => {
            if (input.selectedIndex === 0) {
                ready = false;
            }
        });

        // update update button
        form.querySelector(".productFormPairModalUpdate").disabled = !ready;
    }));

    // update pair
    section.querySelectorAll(".productFormPairModalContent").forEach(element => {
        element.addEventListener("submit", function (e) {
            e.preventDefault();

            // save pair element
            let pairElement = this.closest(".productFormPair");

            // set this option as active
            pairElement.classList.add("active");

            // update options attribute only if the option isn't the initial one
            let options = {};
            this.closest(".productFormPairModal").querySelectorAll(`.productFormPairModalLabelSelect`).forEach(element => {
                if (!element.value.includes("Choose")) {
                    options[element.getAttribute("name")] = element.value;
                }
            });

            pairElement.setAttribute("options", JSON.stringify(options));

            // close modal
            section.querySelector(".productFormPairModal[open]").close();

            updateProduct();
        });
    });

    // remove
    section.querySelectorAll(".productFormPairRemove").forEach(element => {
        element.addEventListener("click", function () {
            // save pair element
            let pairElement = this.closest(".productFormPair");

            // remove active and options
            pairElement.classList.remove("active");
            pairElement.removeAttribute("options");

            // update product
            updateProduct();

            // check if there are no more left, reset the swiper to slide 1 and remove active classes on lebels
            if (section.querySelectorAll(".productFormPair.active").length === 0) {
                section.querySelector(".productFormSwiper").classList.add("active");
                section.querySelector(".productFormForm").classList.remove("active");
                section.querySelectorAll(".productFormOptionSlideLabel.active").forEach(element => element.classList.remove("active"));
                productFormSwiper.slideTo(0);
            }
        });
    })

    // same as first
    section.querySelector(".productFormActionSame").addEventListener("click", function () {
        // check for a free slot
        let nextFree = section.querySelector(".productFormPair:not(.active)");
        if (nextFree) {
            nextFree.classList.add("active");
            nextFree.setAttribute("options", section.querySelector(".productFormPair").getAttribute("options"));
        }
        updateProduct();
    });

    // new pair
    section.querySelector(".productFormActionNew").addEventListener("click", function () {
        //check for a free slot
        let nextFree = section.querySelector(".productFormPair:not(.active)");
        if (nextFree) {
            nextFree.classList.add("active");
            nextFree.querySelector(".productFormPairModal").showModal();
        }
    });

    // forced second pair: open the next pair prefilled with the first pair's options
    function addSecondPair() {
        // find the next available pair slot
        let nextFree = section.querySelector(".productFormPair:not(.active)");
        if (!nextFree) {
            return;
        }

        // mark the slot active so it's included in the order once confirmed
        nextFree.classList.add("active");

        // prefill the modal selects with the first pair's options when each value is valid
        let firstOptions = JSON.parse(section.querySelector(".productFormPair").getAttribute("options"));
        let allOptionsAvailable = true;
        nextFree.querySelectorAll(".productFormPairModalLabelSelect").forEach(element => {
            if (element.querySelector(`option[value="${firstOptions[element.getAttribute("name")]}"]`)) {
                element.value = firstOptions[element.getAttribute("name")];
            } else {
                allOptionsAvailable = false;
            }
        });

        // enable the add button when every option prefilled successfully
        if (allOptionsAvailable) {
            nextFree.querySelector(".productFormPairModalUpdate").disabled = false;
        }

        // open the modal so the customer can confirm or adjust the second pair
        nextFree.querySelector(".productFormPairModal").showModal();
    }

    function updateProduct() {
        // reset atc button (atc active)
        section.querySelector(".productFormATC").textContent = "Add To Cart";
        section.querySelector(".productFormATC").classList.add("active");
        section.querySelector(".productFormATC").classList.remove("disabled");
        section.querySelector(".productFormATC").classList.remove("message");

        // show terms
        // section.querySelector(".productFormTerms").classList.remove("active");

        // reset form data
        formData.items = [];
        section.querySelectorAll(".productFormPairTitle")?.forEach(element => element.classList.remove("active"));
        // hide error message
        section.querySelector(".productFormATC").classList.remove("active");
        section.querySelectorAll(".productFormPair.active").forEach((element, index) => {
            // reindex
            element.querySelector(".productFormPairTitle").textContent = `PAIR ${index + 1}`

            // add formdata
            let options = JSON.parse(element.getAttribute("options"));
            let item = getFormData(options, product.handle);

            // check if item is not found (variant can't be found)
            if (item === false || !item.available) {
                // hide atc button
                section.querySelector(".productFormATC").classList.add("active");

                // hide terms
                // section.querySelector(".productFormTerms").classList.add("active");

                let errorMsg = "Sorry, we don't offer a product that meets the selected options.";


                if (!item.available) {
                    errorMsg = "Sorry, this product is currently out of stock.";
                }

                if (item === false) {
                    errorMsg = "Unavailable — this selection is not currently part of our assortment";
                }


                section.querySelector('.productFormErrorMsg').textContent = errorMsg;

                // show error message
                section.querySelector(".productFormError").classList.add("active");

                // find that element
                let productFormPair = section.querySelector(`.productFormPair[options='${JSON.stringify(options)}']`);

                // indicate that this pair is invalid by setting title to active
                productFormPair.querySelector(".productFormPairTitle").classList.add("active");

                // log request
                let formData = new FormData();
                formData.set("handle", product.handle);
                formData.set("options", JSON.stringify(options));
                fetch("https://api.vktry.com/variant-not-found.php", {
                    method: "POST",
                    body: formData
                });

                return;
            }


            // show atc
            section.querySelector(".productFormATC").classList.remove("active");

            // show terms
            // section.querySelector(".productFormTerms").classList.remove("active");

            // hide error message
            section.querySelector(".productFormError")?.classList.remove("active");

            // check for duplicates (id and property, if you check the entire object, the id won't match)
            for (let i = 0; i < formData.items.length; i++) {
                if (formData.items[i].id === item.id && JSON.stringify(formData.items[i].properties) === JSON.stringify(item.properties)) {
                    formData.items[i].quantity++;
                    return;
                }
            }

            // add item to form data
            formData.items.push(item);

        });

        // forced second pair: prompt for a second pair before allowing checkout
        if (forceSecondPair) {
            // total the quantity of all valid pairs currently in the order
            let totalQuantity = 0;
            formData.items.forEach(item => totalQuantity += item.quantity);

            // switch the button to prompt a second pair when only a single valid pair is selected
            if (totalQuantity > 0 && totalQuantity < 2 && !section.querySelector(".productFormATC").classList.contains("active")) {
                section.querySelector(".productFormATC").textContent = "Add 2nd Silver Pair";
                section.querySelector(".productFormATC").classList.add("forcePair");
            } else {
                section.querySelector(".productFormATC").classList.remove("forcePair");
            }
        }
    }

    // dynamic shoe size title
    section.querySelectorAll(".productFormOptionSlideLabel[data-group='gender']").forEach(element => {
        element.addEventListener("click", function () {
            section.querySelector('.productFormOptionSlideTitleGender').textContent = element.textContent;
        })
    })


    /**************
     Product ATC
     ***************/

    section.querySelector(".productFormATC").addEventListener("click", async function () {

        // forced second pair: open a prefilled second pair instead of checking out
        if (this.classList.contains("forcePair")) {
            addSecondPair();
            return;
        }

        // add loading animation
        this.classList.add("loading");

        // add product
        await addProduct(formData);

        // stop loading
        this.classList.remove("loading");


        // check for upsell
        await openUpsell();

        // open cart
        await openCart();
    });

    /********************************** Shoe Size **********************************/


    // open shoe size modal
    document.querySelectorAll(".openShoeSize").forEach(element => {
        element.addEventListener("click", function () {
            // Find the correct shoe size modal

            // The modal to open is based on the sport
            // Gold: Basketball, fitness, racquet sports, running, volleyball, walking/hiking, everyday
            // Black: Baseball, boxing, football, golf, lacrosse, rugby, ultimate frisbee, [NEW -> ]Cheerleading, Track, Soccer
            // Red: REMOVED and uses black now, was Cheerleading, Track, Soccer
            let sport = document.querySelector(`.productFormOptionSlideLabel.active[data-group="sport"]`)?.dataset?.value;

            if (sport === "Basketball" || sport === "Fitness" || sport === "Tennis/Pickleball" || sport === "Running" || sport === "Volleyball" || sport === "Hiking" || sport === "Walking" || sport === "Other") {
                document.querySelector('#shoeSizeGold').showModal();
            } else {
                document.querySelector('#shoeSizeBlack').showModal();
            }

            document.querySelector("body").classList.add("noScroll");

        })
    });

    // open clog size modal
    document.querySelectorAll(".upsellSize")?.forEach(element => {
        element.addEventListener("click", function () {
            document.querySelector('#shoeSizeClog').showModal();
            document.querySelector("body").classList.add("noScroll");
        })
    });

    //close shoe size event listener
    document.querySelectorAll(".shoeSizeContentClose")?.forEach(function (element) {
        element.addEventListener("click", async function () {
            let target = this.dataset.target;
            await closeSize(target);

        });
    });

    //close shoe size event listener
    document.querySelectorAll(".shoeSize")?.forEach(function (element) {
        element.addEventListener("click", async function (e) {
            if (e.target === this) {
                let target = element.id;
                await closeSize(target);

            }
        });
    });


    // close shoe size
    function closeSize(target) {
        document.querySelector(`#${target}`).close();
        document.querySelector("body").classList.remove("noScroll");
    }

    // register dialogs
    // wait for document to load first
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll("dialog.shoeSize")?.forEach(function (element) {
            dialogPolyfill.registerDialog(element);
        });
    });


    /**************
     Product Upsells
     ***************/

        // upsell swiper
    let upsellSwiper = new Swiper('.upsellSwiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            pagination: {
                el: '.upsellSwiperFooterPag',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "</span>";
                },
            },
        });

    // store the swiper slides to use for later
    let socksSlide = document.querySelector('#upsellSocks');
    let boostsSlide = document.querySelector('#upsellBoosts');
    let gripsSlide = document.querySelector('#upsellGrips');
    let clogsSlide = document.querySelector('#upsellClogs');
    let silverSlide = document.querySelector('#upsellSilver');
    let tag = '';

    // map the sportToUpsell titles to the slides
    let upsellTitleToUpsellSlide = {
        "Ankle Boosts": boostsSlide,
        "Grip Socks": gripsSlide,
        "Propulsion Socks": socksSlide,
        "Recovery Clogs": clogsSlide,
        "Silver Insoles": silverSlide
    }

    // add to cart event listeners
    document.querySelectorAll(".upsellCheckout").forEach(element => {
        element.addEventListener("click", async function () {

            // Used in Discount Kit to target specific upsell products
            let discountProperty = '';

            // start loading
            this.classList.add("loading");

            // determine the first insole gender and size
            const firstPair = JSON.parse(document.querySelector(".productFormPair.active").getAttribute("options"));
            const firstPairGender = firstPair.gender;
            const firstPairSize = firstPair.size;

            // determine the variant id
            let variantID;
            let available = true;

            if (element.classList.contains("boosts")) {
                discountProperty = 'boosts_upsell';
                tag = 'boost upsell';

                if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 9)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 10.5))) {
                    variantID = 42757218402475; // medium
                } else {
                    variantID = 42757218435243; // large
                }
            } else if (element.classList.contains("silverInsole")) {
                tag = 'silver upsell';


            } else if (element.classList.contains("clogs")) {

                discountProperty = 'clog_upsell';
                tag = 'clog upsell';


                // find the variant based on the selected input
                let color = document.querySelector('.upsellSwiperSlideControlsLabelInput:checked').value;
                let clogProduct = JSON.parse(element.dataset.product);

                const insoleColorToClogColor = {
                    "Black": "Carbon Black",
                    "White": "Cloud White",
                }

                // find new variant based on the options
                // find new variant based on the selected clog options
                let clogVariant = clogProduct.variants.find((variant) => {
                    return (
                        variant.options[0] === insoleColorToClogColor[color] &&
                        variant.options[1] === document.querySelector('.upsellOptionsSelect[name="Gender"]').value &&
                        variant.options[2] === document.querySelector('.upsellOptionsSelect[name="Size"]').value
                    );
                });

                if (clogVariant.available) {
                    variantID = clogVariant.id;
                } else {
                    available = false;
                }
            } else if (element.classList.contains("grips")) {
                tag = 'grips upsell';
                discountProperty = 'grip_socks_upsell';
                if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 8)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 11))) {
                    variantID = 52140728320367 // medium
                } else if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 12)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 13))) {
                    variantID = 52140728353135; // large
                } else {
                    variantID = 52140728385903; // xlarge
                }
            } else {
                // compression socks
                discountProperty = 'compression_socks_upsell';
                tag = 'compression socks upsell';

                if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 7)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 9))) {
                    variantID = 42970044924075 // medium
                } else if ((firstPairGender === "Male" && isSizeInRange(firstPairSize, 0, 12)) || (firstPairGender === "Female" && isSizeInRange(firstPairSize, 0, 14))) {
                    variantID = 42970045382827; // large
                } else {
                    variantID = 42970045415595; // xlarge
                }
            }

            // if this has already been added, remove it from the cart
            if (this.classList.contains("added")) {
                let cart = await getCart();

                // find the item
                let item = cart.items.find(item => item.variant_id === variantID);

                // if there is no item, return
                if (!item) {
                    this.textContent = "Add to Cart";
                    this.classList.remove("loading");
                    return;
                }

                await changeProduct({
                    id: item.key,
                    quantity: item.quantity - 1
                });

                this.classList.remove("added");
                this.textContent = "Add to Cart";
                this.classList.remove("loading");
                return;
            }


            // add
            if (available) {
                await addProduct({
                    quantity: 1,
                    id: variantID,
                    properties: {
                        _upsell_tag: tag,
                        _upsell: true,
                        _discount_kit: discountProperty
                    }
                });
            }

            // stop loading
            this.classList.remove("loading");

            element.textContent = "Remove";
            this.classList.add("added");


            // if all upsells have been added, close
            if (document.querySelectorAll(".upsellCheckout.added").length === document.querySelectorAll(".upsellCheckout").length) {
                this.closest(".upsell").close();
            }

            // if there is a next slide, slide to it
            if (this.closest(".swiper-slide").nextElementSibling) {
                upsellSwiper.slideNext();
            }
        });
    });

    // controls
    document.querySelector('.upsellContentControl.prev').addEventListener('click', function () {
        upsellSwiper.slidePrev();
    });

    document.querySelector('.upsellContentControl.next').addEventListener('click', function () {
        upsellSwiper.slideNext();
    });

    /**************
     Gorgias chat
     ***************/
    document.querySelector('.productChat')?.addEventListener('click', function () {
        // open gorgias chat
        if (GorgiasChat) {
            GorgiasChat.open()
        }

    })


    /********************************************** Upsell ***************************************/

    function isSizeInRange(currentSize, min, max) {
        const range = currentSize.split('-').map(parseFloat);
        const size = parseFloat(range[0]);
        return !isNaN(size) && size >= min && size <= max;
    }

    // open ankle upsell
    async function openUpsell() {

        // get sport
        let options = JSON.parse(section.querySelector(`.productFormPair.active`).getAttribute("options"));

        let sport = options.sport;

        // get the sport to upsell slides
        let slides = sportToUpsell[sport]

        // if there are no slides, return
        if (!slides) {
            return;
        }


        // update swiper controls
        document.querySelectorAll('.upsellContentControl').forEach(element => element.classList.remove("active"));
        document.querySelector('.upsellSwiperFooter').classList.remove("active");

        if (slides.length > 1) {
            document.querySelectorAll('.upsellContentControl').forEach(element => element.classList.add("active"));
            document.querySelector('.upsellSwiperFooter').classList.add("active");
        }

        // remove all swiper slides
        upsellSwiper.removeAllSlides();


        // TEMP
        // upsellSwiper.appendSlide(upsellTitleToUpsellSlide['Silver Insoles']);

        // add in the correct slides
        for (let slide of slides) {
            upsellSwiper.appendSlide(upsellTitleToUpsellSlide[slide]);
        }

        // check if clog is available in selected variant, if not disable
        // determine the first insole gender and size
        let firstPair = JSON.parse(document.querySelector(".productFormPair.active").getAttribute("options"));
        let firstPairGender = firstPair.gender;
        let firstPairSize = firstPair.size;

        // find the variant based on the selected input
        let color = document.querySelector('.upsellSwiperSlideControlsLabelInput:checked')?.value;
        let clogProduct = JSON.parse(document.querySelector('#upsellClogs').querySelector('.upsellCheckout')?.dataset.product);

        const insoleColorToClogColor = {
            "Black": "Carbon Black",
            "White": "Cloud White",
        }

        // auto select the correct gender and size
        document.querySelectorAll('.upsellOptionsSelect[name="Gender"] option').forEach(option => option.selected = option.value === firstPairGender);
        document.querySelectorAll('.upsellOptionsSelect[name="Size"] option').forEach(function (option) {
            let sizeSplit = option.value.split('-');
            if (sizeSplit[0] === firstPairSize || sizeSplit[1] === firstPairSize) {
                option.selected = true;
            }
        })

        // find new variant based on the selected clog options
        let clogVariant = clogProduct.variants.find((variant) => {
            return (
                variant.options[0] === insoleColorToClogColor[color] &&
                variant.options[1] === document.querySelector('.upsellOptionsSelect[name="Gender"]').value &&
                variant.options[2] === document.querySelector('.upsellOptionsSelect[name="Size"]').value
            );
        });

        if (!clogVariant) {
            // disable the clog upsell
            document.querySelector('#upsellClogs').querySelector('.upsellCheckout').disabled = true;
            document.querySelector('#upsellClogs').querySelector('.upsellCheckout').textContent = 'Unavailable';
        }

        // open the upsell
        document.querySelector(`#upsell`).showModal();

        document.querySelector("body").classList.add("noScroll");

        // wait for modal to be closed
        await new Promise((resolve, reject) => {
            document.querySelector(`#upsell`).addEventListener("close", function (e) {
                resolve('closed');
            });
        });
    }

    // clog upsell options changes
    document.querySelectorAll('#upsellClogs select, #upsellClogs input').forEach(element => {
        element.addEventListener('change', (e) => {
            updateClogsUpsell();
        })
    })

    // update the clogs ATC based on the selected clog inputs
    function updateClogsUpsell() {
        console.log('change')

        // find the variant based on the selected input
        let color = document.querySelector('.upsellSwiperSlideControlsLabelInput:checked')?.value;
        let clogProduct = JSON.parse(document.querySelector('#upsellClogs').querySelector('.upsellCheckout')?.dataset.product);

        const insoleColorToClogColor = {
            "Black": "Carbon Black",
            "White": "Cloud White",
        }

        // find new variant based on the selected clog options
        let clogVariant = clogProduct.variants.find((variant) => {
            return (
                variant.options[0] === insoleColorToClogColor[color] &&
                variant.options[1] === document.querySelector('.upsellOptionsSelect[name="Gender"]').value &&
                variant.options[2] === document.querySelector('.upsellOptionsSelect[name="Size"]').value
            );
        });

        if (!clogVariant) {
            // disable the clog upsell
            document.querySelector('#upsellClogs').querySelector('.upsellCheckout').disabled = true;
            document.querySelector('#upsellClogs').querySelector('.upsellCheckout').textContent = 'Unavailable';
            return
        }

        document.querySelector('#upsellClogs').querySelector('.upsellCheckout').disabled = false;
        let total = price(document.querySelector('.upsellCheckout.clogs').dataset.salePrice, true);
        document.querySelector('#upsellClogs').querySelector('.upsellCheckout').textContent = `Add to Cart - ${total}`;
    }


    // close events
    document.querySelectorAll(".upsell").forEach(element => {
        // exist backdrop
        element.addEventListener("click", function (e) {
            if (e.target === this) {
                this.close();
                document.querySelector("body").classList.remove("noScroll");

            }
        })
    });

    // close upsell via button
    document.querySelectorAll(".upsellClose").forEach(element => {
        element.addEventListener("click", function () {
            this.closest(".upsell").close();
            document.querySelector("body").classList.remove("noScroll");
        });
    });


    // register dialog
    dialogPolyfill.registerDialog(document.querySelector("#upsell"));

    /**************
     Money Back
     ***************/

    // open moneyBack dialog
    document.querySelectorAll('.openMoneyBack').forEach(function (element) {
        element.addEventListener('click', function () {
            document.querySelector("#moneyBack").showModal();
            document.querySelector("body").classList.add("noScroll");
        });
    })

    // close moneyBack
    function closePopup() {
        document.querySelector("#moneyBack").close();
        document.querySelector("body").classList.remove("noScroll");
    }

    // close moneyBack event listener
    document.querySelectorAll(".moneyBackClose").forEach(function (element) {
        element.addEventListener("click", closePopup);
    });

    document.querySelector("#moneyBack").addEventListener("click", function (e) {
        if (e.target === this) {
            closePopup();
        }
    })

    // close event
    document.querySelector("#moneyBack").addEventListener("close", function () {
        document.querySelector("body").classList.remove("noScroll");
    });

    // register dialog
    dialogPolyfill.registerDialog(document.querySelector("#moneyBack"));


    // delete the hidden upsells from the DOM
    document.querySelector('.hiddenUpsells').remove();


}())